import { render } from "./Approve.vue?vue&type=template&id=69ce2cff&scoped=true"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"

import "./Approve.vue?vue&type=style&index=0&id=69ce2cff&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ce2cff"]])

export default __exports__